import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link, Prompt } from 'react-router-dom'
import InputRange from 'react-input-range'
import Button from './Button'
import Menu from './Menu/Menu'
import MenuItem from './Menu/Item'
import './Toolbar.css'
import Tour from 'reactour'
import { Button as BootstrapButton } from 'reactstrap'

import Cube1 from '../../../assets/img/cube/cube-1.png'
import Cube2 from '../../../assets/img/cube/cube-2.png'
import Cube3 from '../../../assets/img/cube/cube-3.png'
import Cube4 from '../../../assets/img/cube/cube-4.png'
import Cube5 from '../../../assets/img/cube/cube-5.png'
import Cube6 from '../../../assets/img/cube/cube-6.png'
import Cube7 from '../../../assets/img/cube/cube-7.png'
import logo from '../../../assets/img/logo-header-white.svg'

const Toolbar = (props) => {
    const [menuCube, setMenuCube] = useState(false)
    const [cubeSkewAngle, setCubeSkewAngle] = useState(45)
    const [isTourOpen, setIsTourOpen] = useState(false)
    const [currentStep, setCurrentStep] = useState(0)

    const toggleTourStatus = () => {
        setIsTourOpen(!isTourOpen)
        setCurrentStep(0)
    }

    const restartTourStatus = (goTo) => {
        toggleTourStatus()
        goTo(0)
    }

    const tourFooter = (goTo, nextPage) => (
        <div className="footer-container">
            <BootstrapButton
                className="next-btn"
                size="sm"
                color="link"
                onClick={() => goTo(nextPage)}
            >
                بعدی
            </BootstrapButton>
            <BootstrapButton
                className="later-btn"
                size="sm"
                color="link"
                onClick={() => restartTourStatus(goTo)}
            >
                بعدا میبینم
            </BootstrapButton>
        </div>
    )

    const finalTourFooter = (goTo) => (
        <div className="footer-container">
            <BootstrapButton
                className="next-btn"
                size="sm"
                color="link"
                onClick={() => restartTourStatus(goTo)}
            >
                اتمام
            </BootstrapButton>
        </div>
    )

    const steps = [
        {
            selector: '.Toolbar button:nth-child(3)',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">1</span>
                        ابزار 'رسم مسیر' را انتخاب کنید
                    </p>
                    {tourFooter(goTo, 1)}
                </Fragment>
            ),
            action: (node) => {
                if (node && node.focus) {
                    node.focus()
                    node.click()
                }
            },
            stepInteraction: false,
        },
        {
            selector: 'canvas',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">2</span>
                        اطراف ناحیه دلخواه جهت امتحان کردن پارچه را انتخاب کنید
                    </p>
                    {tourFooter(goTo, 2)}
                </Fragment>
            ),
            action: (node) => {
                if (node && node.focus) {
                    node.focus()
                    node.click()
                }
            },
            stepInteraction: true,
        },
        {
            selector: '.Toolbar button:nth-child(2)',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">3</span>
                        ابزار 'انتخاب مسیر' را انتخاب کنید
                    </p>
                    {tourFooter(goTo, 3)}
                </Fragment>
            ),
            action: (node) => {
                if (node) {
                    node.click()
                }
            },
            stepInteraction: false,
        },
        {
            selector: 'canvas',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">4</span>
                        با انتخاب مسیر و سپس جابجایی نقاط، می‎توان دقت انتخاب مسیر را افزایش دهید
                    </p>
                    {tourFooter(goTo, 4)}
                </Fragment>
            ),
            action: (node) => {
                if (node && node.focus) {
                    node.focus()
                    node.click()
                }
            },
            stepInteraction: true,
        },
        {
            selector: '.Toolbar div:nth-of-type(3)',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">5</span>
                        در صورت هرگونه اشتباه امکان بازگشت به یک مرحله یا بازگشت به مرحله اول نیز وجود دارد
                    </p>
                    {tourFooter(goTo, 5)}
                </Fragment>
            ),
            action: (node) => {
                if (node && node.focus) {
                    node.focus()
                    node.click()
                }
            },
            stepInteraction: false,
        },
        {
            selector: '.Toolbar div:nth-of-type(2) button',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">6</span>
                        پس از تکمیل انتخاب مسیر، 'وضعیت پرسکتیو' را انتخاب کنید
                    </p>
                    {tourFooter(goTo, 6)}
                </Fragment>
            ),
            action: (node) => {
                if (node) {
                    node.click()
                }
            },
            stepInteraction: true,
        },
        {
            selector: '.Toolbar .pers-menu-items',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">7</span>
                        زاویه و نحوه قرارگیری ناحیه انتخاب شده را در تصویر انتخاب کنید
                    </p>
                    {tourFooter(goTo, 7)}
                </Fragment>
            ),
            action: (node) => {
                if (node) {
                    node.click()
                }
            },
            stepInteraction: true,
        },
        {
            selector: 'canvas',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">8</span>
                        با جابجایی نقاط جهت خواب پارچه و نحوه قرارگیری آن در نقاط مختلف تغییر خواهد کرد
                    </p>
                    {tourFooter(goTo, 8)}
                </Fragment>
            ),
            stepInteraction: true,
        },
        {
            selector: '.Toolbar .pers-menu .input-range',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">9</span>
                        با جابجایی اسلایدر زاویه شکست پارچه در نقاط میانی تغییر خواهد کرد
                    </p>
                    {tourFooter(goTo, 9)}
                </Fragment>
            ),
            stepInteraction: true,
        },
        {
            selector: '.Toolbar .pers-menu button',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">10</span>
                        پس از انجام تغییرات و رسیدن به مکان مورد انتظار دکمه 'تایید' را انتخاب کنید
                    </p>
                    {tourFooter(goTo, 10)}
                </Fragment>
            ),
            stepInteraction: true,
        },
        {
            selector: '.Toolbar div:nth-of-type(5)',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">11</span>
                        پس از انجام تغییرات و برای نگهداری تغییرات بر روی دکمه 'ذخیره' کلیک کنید
                    </p>
                    {tourFooter(goTo, 11)}
                </Fragment>
            ),
            stepInteraction: false,
        },
        {
            selector: '.Toolbar div:nth-of-type(6)',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">12</span>
                        برای بازگشت به صفحه اصلی بر روی دکمه 'بازگشت' را انتخاب کنید
                    </p>
                    {finalTourFooter(goTo)}
                </Fragment>
            ),
            stepInteraction: false,
        },
    ]

    const { activeTool, fullscreen, imageSize, showLayers } = props

    const menuHandler = (showMenu, showCube, type) => {
        setMenuCube(showMenu)
        // props.stateCubeHandler(showCube, type)
        props.stateDynamicCubeHandler(showCube, type)
    }

    return (
        <div className={'Toolbar'}>
            <Tour
                steps={steps}
                isOpen={isTourOpen}
                disableDotsNavigation={true}
                showNumber={false}
                showButtons={false}
                showCloseButton={false}
                goToStep={currentStep}
                onRequestClose={toggleTourStatus}
                getCurrentStep={(step) => setCurrentStep(step)}
                disableInteraction={false}
                closeWithMask={false}
                rounded={8}
            />
            <a className="help-item" onClick={toggleTourStatus}>
                راهنمای استفاده
            </a>
            <div>
                <Button
                    tool={'move'}
                    title={'ابزار حرکت (V)'}
                    active={activeTool === 'move'}
                    disabled={props.showDynamicCube}
                    setTool={props.setTool}
                >
                    <i className={'material-icons'}>pan_tool</i>
                </Button>
                <Button
                    tool={'select'}
                    title={'ابزار انتخاب مسیر (A)'}
                    active={activeTool === 'select'}
                    disabled={props.showDynamicCube}
                    setTool={props.setTool}
                >
                    <i className={'material-icons'}>touch_app</i>
                </Button>
                <Button
                    tool={'pen'}
                    title={'ابزار رسم مسیر (P)'}
                    disabled={props.showDynamicCube}
                    active={activeTool === 'pen'}
                    setTool={props.setTool}
                >
                    <i className={'material-icons'}>create</i>
                </Button>
                <Button
                    tool={'fastPen'}
                    title={'ابزار رسم سریع مسیر (l)'}
                    disabled={props.showDynamicCube}
                    active={activeTool === 'fastPen'}
                    setTool={props.setTool}
                >
                    <i className={'material-icons'}>timeline</i>
                </Button>
                {props.showDynamicCube ? (
                    <Button
                        title={'حذف'}
                        onClick={() => props.deleteDynamicCubeHandler()}
                    >
                        <i className={'material-icons'}>delete</i>
                    </Button>
                ) : (
                    <Button
                        tool={'delete'}
                        title={'ابزار حذف آیتم (D)'}
                        disabled={props.showDynamicCube}
                        active={activeTool === 'delete'}
                        setTool={props.setTool}
                    >
                        <i className={'material-icons'}>delete</i>
                    </Button>
                )}
            </div>
            <span></span>
            <div className={'pers-menu'}>
                {/* <Button
          tool={'2d'}
          title={'ابزار دو بعدی'}
          active={activeTool === '2d'}
          setTool={props.setTool}
        >
          <i className={'material-icons'}>view_comfy</i>
        </Button> */}

                {!props.showDynamicCube ? (
                    <Button
                        title={'وضعیت پرسپکتیو'}
                        onClick={() => {
                            let isShowMenu = true
                            props.setDefaultView()
                            props.data.layers[0].children.forEach(
                                (element, index) => {
                                    if (
                                        element.id === props.selectedItem &&
                                        element.dimension
                                    ) {
                                        isShowMenu = false
                                        // props.stateCubeHandler(
                                        //     true,
                                        //     element.dimType
                                        // )
                                        props.stateDynamicCubeHandler(
                                            true,
                                            element.dimType,
                                            () =>
                                                setCubeSkewAngle(
                                                    props.getInitialCubeSkewAngle()
                                                )
                                        )
                                    }
                                }
                            )

                            isShowMenu && setMenuCube(!menuCube)
                        }}
                        disabled={props.selectedItem == null}
                    >
                        <i className={'material-icons'}>3d_rotation</i>
                    </Button>
                ) : (
                    <React.Fragment>
                        <Button
                            title={'تایید'}
                            onClick={() => props.confirmDynamicCubeHandler()}
                        >
                            <i className={'material-icons'}>check</i>
                        </Button>
                        <Button
                            title={'کنسل'}
                            onClick={() => menuHandler(false, false)}
                        >
                            <i className={'material-icons'}>close</i>
                        </Button>
                        {props.perspectiveType != 1 && (
                            <InputRange
                                minValue={0}
                                maxValue={90}
                                value={cubeSkewAngle}
                                step={2}
                                onChange={(value) => {
                                    setCubeSkewAngle(value)
                                }}
                                onChangeComplete={(value) =>
                                    props.applyCubeSkewChange(cubeSkewAngle)
                                }
                            />
                        )}
                    </React.Fragment>
                )}

                {menuCube && (
                    <div className={'pers-menu-items'}>
                        <div
                            className={'pers-menu-item'}
                            onClick={() => menuHandler(false, true, 1)}
                        >
                            <img src={Cube1} />
                        </div>
                        <div
                            className={'pers-menu-item'}
                            onClick={() => menuHandler(false, true, 2)}
                        >
                            <img src={Cube2} />
                        </div>
                        <div
                            className={'pers-menu-item'}
                            onClick={() => menuHandler(false, true, 3)}
                        >
                            <img src={Cube4} />
                        </div>
                        <div
                            className={'pers-menu-item'}
                            onClick={() => menuHandler(false, true, 4)}
                        >
                            <img src={Cube3} />
                        </div>
                    </div>
                )}
            </div>
            <span></span>
            <div>
                <Button
                    tool={'redo'}
                    title={'حالت فعلی'}
                    active={activeTool === 'redo'}
                    disabled={!isTourOpen && (!props.canRedo || props.showDynamicCube)}
                    onClick={props.redo}
                >
                    <i className={'material-icons'}>redo</i>
                </Button>
                <Button
                    tool={'undo'}
                    title={'حالت قبلی'}
                    active={activeTool === 'undo'}
                    disabled={!isTourOpen && (!props.canUndo || props.showDynamicCube)}
                    onClick={props.undo}
                >
                    <i className={'material-icons'}>undo</i>
                </Button>
                <Button
                    tool={'reset'}
                    title={'حذف تغییرات'}
                    onClick={props.clearHistory}
                    disabled={!isTourOpen && (
                        (!props.canRedo && !props.canUndo) ||
                        props.showDynamicCube)
                    }
                >
                    <i className={'material-icons'}>clear</i>
                </Button>
            </div>
            <span></span>
            <div>
                <Button
                    tool={'layers'}
                    title={
                        showLayers
                            ? 'عدم نمایش لایه‌بندی خطوط'
                            : 'نمایش لایه‌بندی خطوط'
                    }
                    active={activeTool === 'layers'}
                    disabled={props.showDynamicCube}
                    onClick={props.toggleLayers}
                >
                    <i className={'material-icons'}>
                        {showLayers ? 'layers' : 'layers_clear'}
                    </i>
                </Button>
                <Button
                    tool={'fullscreen'}
                    title={
                        fullscreen ? 'خارج شدن از حالت تمام صفحه' : 'تمام صفحه'
                    }
                    disabled={props.showDynamicCube}
                    onClick={props.toggleFullscreen}
                >
                    <i className={'material-icons'}>
                        {fullscreen ? 'fullscreen_exit' : 'fullscreen'}
                    </i>
                </Button>
            </div>
            <span></span>
            <div>
                <Button
                    tool={'save'}
                    title={'ذخیره کردن'}
                    onClick={props.save}
                    disabled={!isTourOpen && (!props.canUndo || props.showDynamicCube)}
                >
                    <i className={'material-icons'}>save</i>
                </Button>
            </div>
            {/* <div>
                <Button
                    tool={'edit'}
                    title={'ویرایش تصویر'}
                    disabled={props.showDynamicCube}
                    onClick={props.photoEditorHandler}
                >
                    <i className={'material-icons'}>color_lens</i>
                </Button>
            </div> */}
            {props.isSaving && (
                <React.Fragment>
                    <div>
                        <span className="is-saving">در حال ذخیره...</span>
                    </div>
                </React.Fragment>
            )}
            <span></span>
            <div>
                <Prompt
                    when={props.canUndo}
                    message="با بازگشت به صفحه قبل، تغییرات شما از بین خواهد رفت. آیا با اینحال می‌خواهید به صفحه قبل بازگردید و تغییرات را نادیده بگیرید؟"
                />

                <Link to={'/app'} title={'پیشخوان'}>
                    بازگشت
                </Link>
            </div>
            <div className="logo-item">
                <img src={logo} />
            </div>
        </div>
    )
}

Toolbar.propTypes = {
    activeTool: PropTypes.string,
    canUndo: PropTypes.bool,
    canRedo: PropTypes.bool,
    fullscreen: PropTypes.bool,
    imageSize: PropTypes.number,
    showLayers: PropTypes.bool,
    save: PropTypes.func,
    setTool: PropTypes.func,
    undo: PropTypes.func,
    redo: PropTypes.func,
    clearHistory: PropTypes.func,
    toggleFullscreen: PropTypes.func,
    toggleLayers: PropTypes.func,
    isSaving: PropTypes.bool,
    savingError: PropTypes.any,
}

export default Toolbar
